import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from '../../public/locales/fr/common.json';
import en from '../../public/locales/en/common.json';
import ar from '../../public/locales/ar/common.json';

const resources = {
    fr: { common: fr },
    en: { common: en },
    ar: { common: ar },
};

// One instance per locale, so concurrent server renders in different
// languages never share (and race on) a single instance's language.
const instances = {};

export const getI18n = (locale = 'fr') => {
    const lng = resources[locale] ? locale : 'fr';
    if (!instances[lng]) {
        const instance = createInstance();
        instance.use(initReactI18next).init({
            lng,
            fallbackLng: 'fr', // Keys are the French text, so missing keys fall back to French
            defaultNS: 'common',
            ns: ['common'],
            resources,
            initAsync: false, // Resources are bundled: init synchronously so SSR renders translated text
            react: {
                useSuspense: false,
            },
        });
        instances[lng] = instance;
    }
    return instances[lng];
};
